export enum CrudViewColumnType {
  AutoDate = 'auto-date',
  DateTime = 'datetime',
  Date = 'date',
  Tag = 'tag',
  TagList = 'tag-list',
  Icon = 'icon',
  Text = 'text',
  Boolean = 'boolean',
  Number = 'number',
  Link = 'link',
  Image = 'image',
  Currency = 'currency',
  Rate = 'rate',
  ActionLink = 'action-link',
  Code = 'code',
  InputTemplate = 'input-template',
  Json = 'json'
}
